'use client';

import ECommerceMenu from '@/components/layouts/ECommerceMenu/ECommerceMenu';
import { signOut, useSession } from 'next-auth/react';
import React from 'react';
import { postSignout } from '../../api/postSignout';

function ECommerceMenuWrapper({
  hasAlertEcItem = false,
}: {
  isOptionNotEntered?: boolean;
  hasPendingEntry?: boolean;
  hasAlertEcItem?: boolean;
  isFamikuji?: boolean;
}) {
  const session = useSession();

  const user = session.data?.user;

  const logout = async () => {
    try {
      await postSignout();
    } finally {
      // 仮にエラーが起きてても強制ログアウト
      signOut();
    }
  };

  return (
    <>
      <ECommerceMenu
        onLogout={logout}
        userCoin={user?.coin}
        userName={user?.name}
        userUnreadMessageBoxCount={user?.unreadMessageBoxCount}
        hasAlertEcItem={hasAlertEcItem}
      />
    </>
  );
}

export default ECommerceMenuWrapper;
